export const filterVoucher = state => state.voucher.filter;
export const voucherStatisticDataDefault = state => state.voucher.voucherStatisticData;
export const voucherListDataDefault = state => state.voucher.voucherListData;
export const currentVoucher = state => state.voucher.currentVoucher;
export const voucherYears = state => state.voucher.voucherYears;
